module.exports = __webpack_public_path__ + "img/selected7-min.45911eb3.png";